import type { CardObject as BaseCard, CardObject as CardData, CardString } from 'hearts-engine';
import { compareCardTo, getCardObjectFromString, getCardString } from 'hearts-engine';

const { POINTER_DOWN, POINTER_UP } = Phaser.Input.Events;
const CARD_BACK_NAME = 'CardBack.png';

export enum CardEvent {
	PRESSED = 'EVT_CARD_PRESSED',
}

class Card extends Phaser.GameObjects.Image {

	card: BaseCard;
	isDragging = false;
	targetX: number;
	targetY: number;
	targetRotation: number;
	pile: string;
	pilez: number;
	isSelected: boolean = false;
	private _showFront = false;
	private isPressing = false;

	constructor(cardString: CardString | CardData, scene: Phaser.Scene, x: number, y: number, showFront = false) {
		super(scene, x, y, 'Deck', CARD_BACK_NAME);
		this.card = (typeof cardString === 'string') ? getCardObjectFromString(cardString) : cardString;
		this._showFront = showFront;
		this.updateTexture();
		this.setInteractive();
		this.on(POINTER_DOWN, () => this.handlePointerDown());
		this.on(POINTER_UP, () => this.handlePointerUp());
	}

	get id(): CardString {
		return getCardString(this.card);
	}

	get cardFrontName(): string {
		return `${this.id}.png`;
	}

	get showFront(): boolean {
		return this._showFront;
	}

	set showFront(showFront: boolean) {
		this._showFront = showFront;
		this.updateTexture();
	}

	updateTexture() {
		this.setTexture('Deck', this._showFront ? this.cardFrontName : CARD_BACK_NAME);
	}

	compareTo(other: Card): number {
		return compareCardTo(this.card, other.card);
	}

	private handlePointerUp() {
		if (this.isPressing) {
			this.emit(CardEvent.PRESSED);
		}

		this.isPressing = false;
	}

	private handlePointerDown() {
		this.isPressing = true;
	}

}

export default Card;
